import { render, staticRenderFns } from "./AppointmentsMap.vue?vue&type=template&id=97bc91ac"
import script from "./AppointmentsMap.vue?vue&type=script&lang=ts"
export * from "./AppointmentsMap.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentsMap.vue?vue&type=style&index=0&id=97bc91ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports